var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip364_2098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip364_2098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9453 27.9297C33.9453 24.6074 31.252 21.9141 27.9297 21.9141C24.6074 21.9141 21.9141 24.6074 21.9141 27.9297C21.9141 31.252 24.6074 33.9453 27.9297 33.9453C31.252 33.9453 33.9453 31.252 33.9453 27.9297Z",
    stroke: "#EBBE7B",
    strokeOpacity: 1,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1157 18.7727C48.9873 13.3728 45.041 8.88501 39.957 6.08374C34.8735 3.28247 28.9717 2.34351 23.2695 3.42871C17.5679 4.51416 12.4238 7.55566 8.72461 12.0286C5.02539 16.5015 3.00342 22.125 3.00781 27.9294",
    stroke: "#EBBE7B",
    strokeOpacity: 1,
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74365 37.0864C6.87207 42.4863 10.8184 46.9739 15.9019 49.7751C20.9858 52.5764 26.8877 53.5154 32.5894 52.4302C38.2915 51.345 43.4355 48.3035 47.1348 43.8306C50.834 39.3577 52.8555 33.7339 52.8516 27.9297",
    stroke: "#EBBE7B",
    strokeOpacity: 1,
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60498 51.168L4.72656 37.0811L18.2095 41.7681",
    stroke: "#EBBE7B",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.69bd88235cd6e8d64c8c6c3c87913ef9.svg";
export { ForwardRef as ReactComponent };